// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
import { AcademyEnrollmentSkeleton } from '@crehana/web/components/Cards/AcademyEnrollmentCard';

const AcademiesSkeleton = () => {
  const { isDark } = useUITheme();

  return (
    <Container type="dashboard">
      {Array.from({ length: 4 }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        // biome-ignore lint/suspicious/noArrayIndexKey: stable list order, index key acceptable here
        <div key={i} className="mb-24 sm:mb-16 mb-12">
          <AcademyEnrollmentSkeleton isDark={isDark} />
        </div>
      ))}
    </Container>
  );
};

export default AcademiesSkeleton;
